import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ServiceDetail2.css";
import cleanImg from "../images/ServiceDetail3.jpg";
import { FaArrowRight } from "react-icons/fa";

const categories = [
  "Road Cleaning",
  "Kitchen Cleaning",
  "House Cleaning",
  "Office Cleaning",
  "Freeze Cleaning",
];

const ServiceDetail2 = () => {
  // ✅ All hooks inside the component
  const [activeCategory, setActiveCategory] = useState("");
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userMessage, setUserMessage] = useState("");
  const navigate = useNavigate(); // ✅ moved inside the component

  // ✅ Handle category click and navigate
  const handleCategoryClick = (cat) => {
    setActiveCategory(cat);
    navigate("/team", { state: { selectedCategory: cat } });
  };

  // ✅ WhatsApp message handler
  const whatsappNumber = "94771234567"; // Change to your number
  const handleWhatsAppSubmit = () => {
    const text = `Hello! 👋%0AI'm interested in *${activeCategory}* service.%0A%0AName: ${userName}%0AEmail: ${userEmail}%0AMessage: ${userMessage}`;
    const url = `https://wa.me/${whatsappNumber}?text=${text}`;
    window.open(url, "_blank");
  };

  return (
    <div className="service-container">
      {/* LEFT SECTION */}
      <div className="service-left">
        <img src={cleanImg} alt="Cleaning Service" className="banner-img" />
        <h2 className="service-title">
          {activeCategory || "Select a Service"}
        </h2>

        <p className="text">
          Premium cleaning includes various services for{" "}
          {activeCategory || "your space"} — you can edit this text.
        </p>

        <div className="service-icons">
          <div className="icon-card">⭐ <p>Reliable Through Experience</p></div>
          <div className="icon-card">🧽 <p>Customizable Services</p></div>
          <div className="icon-card">📅 <p>Booking Online Appointment</p></div>
        </div>

        <h3 className="section-title">Making your home look its best</h3>
        <p className="text">
          More details about why cleaning is important… (edit text)
        </p>
      </div>

      {/* RIGHT SECTION */}
      <div className="service-right">
        <div className="card category-box">
          <h3>Category</h3>
          {categories.map((cat, index) => (
            <button
              key={index}
              className={`category-btn ${
                activeCategory === cat ? "active" : ""
              }`}
              onClick={() => handleCategoryClick(cat)}
            >
              <span>{cat}</span>
              <FaArrowRight className="arrow-icon" />
            </button>
          ))}
        </div>

        <div className="card quote-box">
          <h3>Online Quote</h3>
          <input
            type="text"
            placeholder="Your Name"
            value={userName}
            onChange={(e) => setUserName(e.target.value)}
          />
          <input
            type="email"
            placeholder="Email Address"
            value={userEmail}
            onChange={(e) => setUserEmail(e.target.value)}
          />
          <textarea
            placeholder="Message"
            value={userMessage}
            onChange={(e) => setUserMessage(e.target.value)}
          ></textarea>

          
          
          
          <button className="submit-btn" onClick={handleWhatsAppSubmit}>
            Submit Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServiceDetail2;
